<template lang="pug">
div
  v-card(flat)
    v-card-title Special Event Trash and Recycling
    keep-alive
      validation-observer(
        ref="o08",
        v-slot="{ invalid }",
        :persist="true",
        vid="o08"
      )
        v-container
          v-row
            v-col(:lg="12", :md="12", :sm="12", :cols="12")
              p.pb-0.body-1 Trash/recycling introduction
              p.pb-0.pl-8.text--secondary As part of a commitment to environmental sustainability, Arlington County strives to minimize waste and increase recycling within the County. We encourage event organizers to implement waste reduction strategies and to consider using environmentally preferable products to reduce your event's environmental impact. Refer to our Guide to Hosting a Zero Waste Event [Coming Soon!] for more information or contact the Solid Waste Bureau (SWB) at 703-228-0443 or <a href="mailto:dkrietemeyer@arlingtonva.us">dkrietemeyer@arlingtonva.us</a> for tips and assistance with waste reduction.
          v-row
            v-col(:lg="12", :md="12", :sm="12", :cols="12")
              p.pb-0.body-1 Are you interested in having a water station?
              p.pb-0.pl-8.text--secondary To reduce the amount of single-use water bottles at your event, the County offers a free mobile water station for filling reusable water bottles at large (500+ attendees) events. The event site must have access to potable water from a fire hydrant or water spigot. Contact the Department of Environmental Services (Water Sewer Streets) at 301-213-1615 or <a href="mailto:rwhitejr@arlingtonva.us">rwhitejr@arlingtonva.us</a> if you would like a water station set up at your event.
              validation-provider(
                rules="required",
                v-slot="{ errors }",
                immediate
              )
                v-radio-group(
                  v-model="SEA_WaterStation",
                  row,
                  dense,
                  :disabled="disabled"
                )
                  v-radio(
                    v-for="option in yesNoString",
                    :key="option",
                    :label="option",
                    :value="option"
                  )
                p.pb-0.red--text.text--lighten-1.pl-4 {{ errors[0] }}
          v-row
            v-col(:lg="12", :md="12", :sm="12", :cols="12")
              p.pb-0.body-1 Do you need street sweeping services?
              p.pb-0.pl-8.text--secondary Sweeping before an event is free (occurs 1-2 business days in advance of the event); sweeping after costs $250.
              validation-provider(
                rules="required",
                v-slot="{ errors }",
                immediate
              )
                v-radio-group(
                  v-model="SEA_StreetSweeping",
                  row,
                  dense,
                  :disabled="disabled"
                )
                  v-radio(
                    v-for="option in streetSweeping",
                    :key="option",
                    :label="option",
                    :value="option"
                  )
                p.pb-0.red--text.text--lighten-1.pl-4 {{ errors[0] }}
          v-row
            v-col(:lg="12", :md="12", :sm="12", :cols="12")
              p.pb-0.body-1 Trash/Recycling Removal Plan
              p.pb-0.pl-8.text--secondary For trash and recycling services in a park or in the Rosslyn/Ballston area, contact the Department of Parks and Recreation at 703-228-7632. For trash and recycling services in all others areas, composting services and/or for street cleaning before or after an event, contact the SWB at 703-228-0443. To reserve trash, recycling or composting containers for your event free of charge, call the SWB at703-228-0443 or email <a href="mailto:dkrietemeyer@arlingtonva.us">dkrietemeyer@arlingtonva.us</a>.
          v-row
            v-col(:lg="12", :md="12", :sm="12", :cols="12")
              p.pb-0.body-1 Waste Diversion: Recycling, Composting, and Trash
              p.pb-0.pl-8.text--secondary All events are required to recycle and applicants must have a waste reduction, trash/recycling plan. Trash, recycling and compost containers can be borrowed from the Solid Waste Bureau free of charge, but the County does not provide waste removal for free. Please answer the following questions about how you will manage materials generated at or brought to the event and how you will encourage waste reduction.
          v-row
            v-col(:lg="12", :md="12", :sm="12", :cols="12")
              p.pb-0.body-1 Disposal Plan
              p.pb-0.pl-8.text--secondary How will you collect and remove trash, recyclable, and compostable (if applicable) materials from your event site? What is your plan? To reserve trash, recycling or composting containers for your event for free of charge, call the SWB at 703-228-0443 or email <a href="mailto:dkrietemeyer@arlingtonva.us">dkrietemeyer@arlingtonva.us</a>
              validation-provider(
                rules="required",
                v-slot="{ errors }",
                immediate
              )
                v-textarea.pb-3.pl-3(
                  outlined,
                  hide-details,
                  dense,
                  v-model="SEA_WasteDisposalPlan",
                  :disabled="disabled"
                )
                p.pb-0.red--text.text--lighten-1.pl-4 {{ errors[0] }}
          v-row
            v-col(:lg="12", :md="12", :sm="12", :cols="12")
              p.pb-0.body-1 Waste Material Types &amp; Quantities
              p.pb-0.pl-8.text--secondary List the waste material types and quantities (if known) expected to be generated at the event (e.g. bottled water|10 cases, Cardboard boxes|50, etc).
              v-textarea.pb-3.pl-3(
                outlined,
                hide-details,
                dense,
                v-model="SEA_WasteTypeQual",
                :disabled="disabled"
              )
          v-row
            v-col(:lg="12", :md="12", :sm="12", :cols="12")
              p.pb-0.body-1 Are you interested in collecting compostable materials?
              p.pb-0.pl-8.text--secondary The County will collect organic materials such as food waste or napkins and remove them for composting.
              validation-provider(
                rules="required",
                v-slot="{ errors }",
                immediate
              )
                v-radio-group(
                  v-model="SEA_WasteCompostableMaterials",
                  row,
                  dense,
                  :disabled="disabled"
                )
                  v-radio(
                    v-for="option in yesNoString",
                    :key="option",
                    :label="option",
                    :value="option"
                  )
                p.pb-0.red--text.text--lighten-1.pl-4 {{ errors[0] }}
          v-row
            v-col(:lg="12", :md="12", :sm="12", :cols="12")
              p.pb-0.body-1 Trash and Recyclables Collector
              p.pb-0.pl-8.text--secondary If contracting waste collection services, what is the name of the trash and recycling collector(s)? Note that for large events you must use the County or a private hauler permitted in Arlington County for this service.
              v-text-field.pb-3.pl-3(
                outlined,
                hide-details,
                dense,
                :disabled="disabled",
                v-model="SEA_WasteTrashColl"
              )
          v-row
            v-col(:lg="12", :md="12", :sm="12", :cols="12")
              p.pb-0.body-1 Waste Reduction
              p.pb-0.pl-8.text--secondary How will you encourage waste reduction at your event?
              validation-provider(
                rules="required",
                v-slot="{ errors }",
                immediate
              )
                v-textarea.pb-3.pl-3(
                  outlined,
                  hide-details,
                  dense,
                  :disabled="disabled",
                  v-model="SEA_WasteReduction"
                )
                p.pb-0.red--text.text--lighten-1.pl-4 {{ errors[0] }}
</template>


<script>
import { mapState } from "vuex";
import { mapFields } from "vuex-map-fields";
import store from "../store";

export default {
  components: {
    //
  },
  store,
  computed: {
    ...mapState({
      data: (state) => state.data,
      yesNoString: (state) => state.yesNoString,
    }),
    ...mapFields([
      "data.SEA_WaterStation",
      "data.SEA_StreetSweeping",
      "data.SEA_WasteDisposalPlan",
      "data.SEA_WasteTypeQual",
      "data.SEA_WasteCompostableMaterials",
      "data.SEA_WasteVolunteer",
      "data.SEA_WasteTrashColl",
      "data.SEA_WasteReduction",
      "data.disabled",
    ]),
  },
  data: () => ({
    streetSweeping: [
      "Yes - before",
      "Yes - after",
      "Yes - before & after",
      "No",
    ],
  }),
  methods: {
    //
  },
};
</script>